import { addDays } from "date-fns";

// Helper function to get the first business day of a month (Monday-Friday)
export const getFirstBusinessDayOfMonth = (
  year: number,
  month: number,
): Date => {
  const firstDayOfMonth = new Date(year, month, 1);
  const dayOfWeek = firstDayOfMonth.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday

  // If it's Sunday (0), move to Monday (1)
  // If it's Saturday (6), move to Monday of next week (8)
  if (dayOfWeek === 0) {
    return addDays(firstDayOfMonth, 1); // Monday
  } else if (dayOfWeek === 6) {
    return addDays(firstDayOfMonth, 2); // Monday of next week
  } else {
    return firstDayOfMonth; // Already a business day
  }
};
